<template>
	<div class="dialog center bg-white light expired-licence-alert">
		<div class="dialog-content expired-licence-content">
			<div class="warning-badge">
				<span class="mif-warning"></span>
			</div>

			<h3 class="text-bold mb-2">{{ $t("Your licence has expired") }}</h3>
			<div class="title-divider"></div>

			<p v-if="expirationDateText != ''" class="mb-0">
				<span>{{ $t("Your licence expired on") }}</span>
				<b class="text-red"> {{ expirationDateText }}</b>
			</p>

			<p class="mb-6">{{ $t("Reactivate your licence to continue using all Iperius ONE features.") }}</p>

			<a class="button secondary reactivate-button" :href="$root.authObj.renew_url" target="_blank">
				{{ $t("Click here to reactivate your licence") }}
			</a>
		</div>
	</div>
</template>

<script>
import { DateHelper } from '../../utils/objects';

export default {
	name: "ExpiredLicenceAlert",
	data() {
		return {
			expirationDateText: "",
		}
	},
	mounted() {
		var auth = this.$root.getAuth();

		if (auth == null) {
			this.expirationDateText = "";
			return;
		}

		this.expirationDateText = DateHelper.toPrettyDate(auth.dataora_scadenza) ?? "";

	},

}
</script>

<style scoped>
.expired-licence-alert {
	width: 420px;
	min-height: fit-content;
	border-radius: 6px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, .18);
}

.expired-licence-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 28px 36px 32px;
	text-align: center;
}

.warning-badge {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 76px;
	height: 76px;
	margin-bottom: 18px;
	border-radius: 50%;
	/*background: #fff3dd;*/
	color: #f6a623;
	font-size: 75px;
}

.title-divider {
	width: 42px;
	height: 1px;
	margin: 6px 0 18px;
	background: #d7d7d7;
}

.reactivate-button {
	width: 100%;
	max-width: 320px;
	height: 42px;
	line-height: 42px;
	font-weight: 600;
}
</style>
